module.exports = __webpack_public_path__ + "static/media/100k-120days-report.47a23fb3.svg";